import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { getLDSproperty } from "./graphql/queries";

import Table from "react-bootstrap/Table";

const PropertyDetail = ({ pid }) => {
  const [APN, setAPN] = useState("...");
  const [address, setAddress] = useState("...");
  const [city, setCity] = useState("...");
  const [state, setState] = useState("...");
  const [acreage, setAcreage] = useState("...");
  const [assetCategory, setAssetCategory] = useState("...");
  const [county, setCounty] = useState("...");
  const [GPS, setGPS] = useState([]);
  const [reportedOwner, setReportedOwner] = useState([]);
  const [taxYear, setTaxyear] = useState("...");
  const [totalAssessedValue, setTotalAssessedValue] = useState("...");
  const [totalMarketValue, setTotalMarketValue] = useState("...");
  useEffect(() => {
    getPropertyDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getPropertyDetail = async () => {
    try {
      await API.graphql(graphqlOperation(getLDSproperty, { id: pid })).then(
        (res) => {
          setAPN(res.data.getLDSproperty.APN);
          setAddress(res.data.getLDSproperty.Address);
          setCity(res.data.getLDSproperty.City);
          setState(res.data.getLDSproperty.State);
          setAcreage(res.data.getLDSproperty.Acreage);
          setCounty(res.data.getLDSproperty.County);
          setAssetCategory(res.data.getLDSproperty.AssetCategory);
          setGPS(res.data.getLDSproperty.GPS);
          setReportedOwner(res.data.getLDSproperty.ReportedOwner);
          setTaxyear(res.data.getLDSproperty.TaxYear);
          setTotalAssessedValue(res.data.getLDSproperty.TotalAssessedValue);
          setTotalMarketValue(res.data.getLDSproperty.TotalMarketValue);
        }
      );
    } catch (err) {
      console.log("error on getting item", err);
    }
  };
  return (
    <>
      <div>
        <Table responsive>
          <thead>
            <tr>
              <th>Title</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>APN</td>
              <td>{APN}</td>
            </tr>
            <tr>
              <td>Address</td>
              <td>{address || "no address"}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{city}</td>
            </tr>
            <tr>
              <td>State</td>
              <td>{state}</td>
            </tr>
            <tr>
              <td>Acreage</td>
              <td>{acreage}</td>
            </tr>
            <tr>
              <td>County</td>
              <td>{county}</td>
            </tr>
            <tr>
              <td>Asset Category</td>
              <td>{assetCategory}</td>
            </tr>
            <tr>
              <td>GPS</td>
              <td>{GPS[0] + ", " + GPS[1]}</td>
            </tr>
            <tr>
              <td>Reported Owner</td>
              <td>{reportedOwner}</td>
            </tr>
            <tr>
              <td>Tax Year</td>
              <td>{taxYear}</td>
            </tr>
            <tr>
              <td>Total Assessed Value</td>
              <td>{"$" + totalAssessedValue.toLocaleString()}</td>
            </tr>
            <tr>
              <td>Total Market Value</td>
              <td>{"$" + totalMarketValue.toLocaleString()}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default PropertyDetail;
